import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    name: 'Dashboard Agua Quito',
    url: '/dashboardaguaquito',
    icon: 'cil-bar-chart',
  },
  /*{
    title: true,
    name: 'Theme'
  },
  {
    name: 'Colors',
    url: '/theme/colors',
    icon: 'icon-drop'
  },
  {
    name: 'Typography',
    url: '/theme/typography',
    icon: 'icon-pencil'
  },*/
  {
    title: true,
    name: 'Medidor de Agua'
  },
  {
    name: 'Medidores',
    url: '/medidores/listado',
    icon: 'cil-gauge',
    children: [
      {
        name: 'Lista Mediciones',
        url: '/medidores/listado',
        icon: 'fa fa-list-ol'
      },
      {
        name: 'Detalle Medidores',
        url: '/medidores/envio',
        icon: 'cil-monitor'
      },
      {
        name: 'Estado Medidores',
        url: '/medidores/lmedidores',
        icon: 'cil-monitor'
      },
      {
        name: 'Registro',
        url: '/medidores/registro',
        icon: 'cil-note-add'
      },


    ]
  },
  {
    name: 'Gateways',
    url: '/gateways',
    icon: 'cil-router',
    children: [
      {
        name: 'Registro',
        url: '/gateways/registro',
        icon: 'cil-note-add'
      },
      {
        name: 'Mapas',
        url: '/gateways/mapas',
        icon: 'cil-note-add'
      },
    ]
  },
  {
    name: 'Usuarios',
    url: '/usuarios',
    icon: 'cil-user',
    children: [
      {
        name: 'Registro',
        url: '/usuarios/registro',
        icon: 'cil-note-add'
      },

    ]
  },
  {
    title: true,
    name: 'Medidor de Energía Eléctrica',

  },
  {
    name: 'Estado Medidores',
    url: '/medidorluz/listado',
    icon: 'cil-gauge',


    children: [
      {
        name: 'Lista Mediciones Energía Eléctrica',
        url: '/medidorluz/listado',
        icon: 'fa fa-list-ol',

      },
      {
        name: 'Medidores',
        url: '/medidorluz/lmedidores',
        icon: 'cil-monitor'
      },
      {
        name: 'Registro',
        url: '/medidorluz/registro',
        icon: 'cil-note-add'
      },


    ]
  },
  {
    name: 'Gateways',
    url: '/gatewaysLuz',
    icon: 'cil-router',
    children: [
      {
        name: 'Registro',
        url: '/gatewaysLuz/registro',
        icon: 'cil-note-add'
      },

    ]
  },
  {
    title: true,
    name: 'Medidor de Gas',


  },
  {
    name: 'Medidores',
    url: '/medidorgas/listado',
    icon: 'cil-gauge',


    children: [
      {
        name: 'Lista Mediciones Gas',
        url: '/medidorgas/listado',
        icon: 'fa fa-list-ol',

      },
      {
        name: 'Estado Medidores',
        url: '/medidorgas/lmedidores',
        icon: 'cil-monitor'
      },
      {
        name: 'Registro',
        url: '/medidorgas/registro',
        icon: 'cil-note-add'
      },


    ]
  },
  {
    name: 'Gateways',
    url: '/gatewaysLuz',
    icon: 'cil-router',
    children: [
      {
        name: 'Registro',
        url: '/gatewaysLuz/registro',
        icon: 'cil-note-add'
      },

    ]
  },
  {
    title: true,
    name: 'Autofacturacion Agua',
    variant: 'info'

  },
  {
    name: 'Autofacturacion',
    url: '/autofacturacion',
    icon: 'cil-router',
    children: [
      {
        name: 'Listado',
        url: '/autofacturacion/listado',
        icon: 'cil-note-add'
      },

    ]
  },
  /* {
     name: 'test',
     url: '/medidores',
     icon: 'icon-puzzle',
     children: [
       {
         name: 'Registro',
         url: '/medidores/flags',
         icon: 'icon-puzzle'
       },
       {
         name: 'Carousels',
         url: '/base/carousels',
         icon: 'icon-puzzle'
       },
       {
         name: 'Collapses',
         url: '/base/collapses',
         icon: 'icon-puzzle'
       },
       {
         name: 'Forms',
         url: '/base/forms',
         icon: 'icon-puzzle'
       },
       {
         name: 'Navbars',
         url: '/base/navbars',
         icon: 'icon-puzzle'
       },
       {
         name: 'Pagination',
         url: '/base/paginations',
         icon: 'icon-puzzle'
       },
       {
         name: 'Popovers',
         url: '/base/popovers',
         icon: 'icon-puzzle'
       },
       {
         name: 'Progress',
         url: '/base/progress',
         icon: 'icon-puzzle'
       },
       {
         name: 'Switches',
         url: '/base/switches',
         icon: 'icon-puzzle'
       },
       {
         name: 'Tables',
         url: '/base/tables',
         icon: 'icon-puzzle'
       },
       {
         name: 'Tabs',
         url: '/base/tabs',
         icon: 'icon-puzzle'
       },
       {
         name: 'Tooltips',
         url: '/base/tooltips',
         icon: 'icon-puzzle'
       }
     ]
   },
   {
     name: 'Gateways',
     url: '/buttons',
     icon: 'icon-cursor',
     children: [
       {
         name: 'Buttons',
         url: '/buttons/buttons',
         icon: 'icon-cursor'
       },
       {
         name: 'Dropdowns',
         url: '/buttons/dropdowns',
         icon: 'icon-cursor'
       },
       {
         name: 'Brand Buttons',
         url: '/buttons/brand-buttons',
         icon: 'icon-cursor'
       }
     ]
   },
   {
     name: 'Charts',
     url: '/charts',
     icon: 'icon-pie-chart'
   },
   {
     name: 'Icons',
     url: '/icons',
     icon: 'icon-star',
     children: [
       {
         name: 'CoreUI Icons',
         url: '/icons/coreui-icons',
         icon: 'icon-star',
         badge: {
           variant: 'success',
           text: 'NEW'
         }
       },
       {
         name: 'Flags',
         url: '/icons/flags',
         icon: 'icon-star'
       },
       {
         name: 'Font Awesome',
         url: '/icons/font-awesome',
         icon: 'icon-star',
         badge: {
           variant: 'secondary',
           text: '4.7'
         }
       },
       {
         name: 'Simple Line Icons',
         url: '/icons/simple-line-icons',
         icon: 'icon-star'
       }
     ]
   },
   {
     name: 'Notifications',
     url: '/notifications',
     icon: 'icon-bell',
     children: [
       {
         name: 'Alerts',
         url: '/notifications/alerts',
         icon: 'icon-bell'
       },
       {
         name: 'Badges',
         url: '/notifications/badges',
         icon: 'icon-bell'
       },
       {
         name: 'Modals',
         url: '/notifications/modals',
         icon: 'icon-bell'
       }
     ]
   },
   {
     name: 'Widgets',
     url: '/widgets',
     icon: 'icon-calculator',
     badge: {
       variant: 'info',
       text: 'NEW'
     }
   },
   {
     divider: true
   },
   {
     title: true,
     name: 'Extras',
   },
   {
     name: 'Pages',
     url: '/pages',
     icon: 'icon-star',
     children: [
       {
         name: 'Login',
         url: '/login',
         icon: 'icon-star'
       },
       {
         name: 'Register',
         url: '/register',
         icon: 'icon-star'
       },
       {
         name: 'Error 404',
         url: '/404',
         icon: 'icon-star'
       },
       {
         name: 'Error 500',
         url: '/500',
         icon: 'icon-star'
       }
     ]
   },
   {
     name: 'Disabled',
     url: '/dashboard',
     icon: 'icon-ban',
     badge: {
       variant: 'secondary',
       text: 'NEW'
     },
     attributes: { disabled: true },
   },
   {
     name: 'Download CoreUI',
     url: 'http://coreui.io/angular/',
     icon: 'icon-cloud-download',
     class: 'mt-auto',
     variant: 'success',
     attributes: { target: '_blank', rel: 'noopener' }
   }*/
];

export const navItemsEpmaps: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },

  {
    title: true,
    name: 'Medidor de Agua'
  },
  {
    name: 'Medidores',
    url: '/medidores/listado',
    icon: 'cil-gauge',
    children: [
      {
        name: 'Lista Mediciones',
        url: '/medidores/listado',
        icon: 'fa fa-list-ol'
      },
      {
        name: 'Medidores',
        url: '/medidores/lmedidores',
        icon: 'cil-monitor'
      },
      {
        name: 'Registro',
        url: '/medidores/registro',
        icon: 'cil-note-add'
      },


    ]
  },


];
export const navItemsAutofacturacion: INavData[] = [
  {
    title: true,
    name: 'Autofacturacion Agua',
    variant: 'info'

  },
  {
    name: 'Autofacturacion',
    url: '/autofacturacion',
    icon: 'cil-router',
    children: [
      {
        name: 'Listado',
        url: '/autofacturacion/listado',
        icon: 'cil-note-add'
      },

    ]
  },
];

export const navItemsLuz: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Medidor de Luz',
    variant: 'info'

  },
  {
    name: 'Medidores',
    url: '/medidorluz/listado',
    icon: 'cil-gauge',


    children: [
      {
        name: 'Lista Mediciones Luz',
        url: '/medidorluz/listado',
        icon: 'fa fa-list-ol',
        variant: 'info',
      },
      {
        name: 'Medidores',
        url: '/medidorluz/lmedidores',
        icon: 'cil-monitor'
      },
      {
        name: 'Registro',
        url: '/medidorluz/registro',
        icon: 'cil-note-add'
      },


    ]
  },
  {
    name: 'Gateways',
    url: '/gatewaysLuz',
    icon: 'cil-router',
    children: [
      {
        name: 'Registro',
        url: '/gatewaysLuz/registro',
        icon: 'cil-note-add'
      },

    ]
  },



];

export const navItemsGas: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Medidor de Gas',
    variant: 'info'
  },
  {
    name: 'Medidores',
    url: '/medidorgas/listado',
    icon: 'cil-gauge',
    children: [
      {
        name: 'Lista Mediciones Gas',
        url: '/medidorgas/listado',
        icon: 'fa fa-list-ol',
        variant: 'info',
      },
      {
        name: 'Registro',
        url: '/medidorgas/registro',
        icon: 'cil-note-add'
      },
    ]
  },
];
